import assignModuleRoutes from '@/store/modules/cataloger/assignModuleRoutes';
import common from './common';
import buyer from './buyer';
import supplier from './supplier';
import supplierAdmin from './supplier_admin';
import admin from './admin';
import publicPaths from './publicPaths';
import terms from './termsAndConditions';

export default {
  admin: [
    ...admin,
  ],
  mro_buyer: [
    ...common,
    ...buyer,
  ],
  mro_mdm_user(modulesName) {
    return assignModuleRoutes(modulesName);
  },
  mro_manage_supplier: [
    ...common,
    ...publicPaths,
    ...supplier,
    ...supplierAdmin,
    ...terms,
  ],
  mro_supplier: [
    ...common,
    ...publicPaths,
    ...supplier,
    ...terms,
  ],
  publicPaths: [
    ...common,
    ...publicPaths,
  ],
};



// WEBPACK FOOTER //
// ./src/router/routes/index.js